import moment from "moment";
import modelBaseV2 from "../model-base-v2.model";

const ACTION = {
  ADD: "ADD",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
};

const SMECustomerIFModelMapModel = {
  getCustomers: () => {
    return modelBaseV2.get("/api/intf-edi/SMECustomer");
  },

  search: (queries) => {
    return modelBaseV2.get("/api/intf-edi/SMEModelMap", {
      params: queries,
    });
  },

  on: (action, data) => {
    return modelBaseV2.post("/api/intf-edi/SMEModelMapAction", {
      body: { ...data, action },
    });
  },

  add: (newItem) => {
    return SMECustomerIFModelMapModel.on(ACTION.ADD, newItem);
  },

  update: (item) => {
    return SMECustomerIFModelMapModel.on(ACTION.UPDATE, item);
  },

  delete: (item) => {
    return SMECustomerIFModelMapModel.on(ACTION.DELETE, item);
  },

  downloadSearchResult: (body) => {
    const paramsMapping = {
      orderBy: "2",
      pageIndex: "3",
      pageSize: "4",
      inputUserID: "7",
      inputCountryCode: "16",
      inputUserLanguageCode: "17",
      sortBy: "24",
      sMEEdiCustomerCode: "75",
      samsungChannel: "76",
      iFChannelAttr1: "77",
      iFChannelAttr2: "78",
      isExcelDownload: "79",
      mapType: "80",
    }

    const params = Object.entries(paramsMapping).map(([key, value]) => {
      let arg = body[key];
      return {
        code: value,
        value: arg
          ? Array.isArray(arg)
            ? arg.join('^')
            : arg.toString()
          : ""
      }
    })

    const exportConfig = {
      excelSheetNames: [
        "SME Customer IF Model Mapping"
      ],
      storedProcedureCode: "42",
      params
    }

    return modelBaseV2.postDownload('/api/executesp/export/file', { body: exportConfig }, `SME_Customer_IF_Model_Mapping_${moment().format('YYYYMMDDhhmm')}.xlsx`);
  }
};

export default SMECustomerIFModelMapModel;
